
import {defineComponent, inject, ref} from "vue"
import NodeList from "@/components/NodeList.vue";
import NodeViewer from "@/components/NodeViewer.vue";
import DefAndGuideList from "@/components/DefAndGuideList.vue";
import DataViewer from "@/components/DataViewer.vue";
import {useMapStore} from "@/mixins/mapStore";
import DataViewerContainer from "@/components/DataViewerContainer.vue";

export default defineComponent({
  name: "TabularView",
  components: {DataViewerContainer, DefAndGuideList, NodeViewer, NodeList, DataViewer},
  emits: {
    "mode:graph": () => true,
  },

  setup() {
    const mapStore = useMapStore()
    const color = ref("red")
    return {
      mapStore
    }
  }
})
